let mobile = 'ontouchstart' in window || navigator.maxTouchPoints

if (mobile) {
    let landscape = window.matchMedia("(orientation: landscape)").matches;
    landscape ? $('.mobile-landscape-modal').addClass('active') : $('.mobile-landscape-modal').removeClass('active')
    window.matchMedia("(orientation: landscape)").addEventListener("change", e => {
        landscape = e.matches;
        landscape ? $('.mobile-landscape-modal').addClass('active') : $('.mobile-landscape-modal').removeClass('active')
    });
}



export { mobile }